import { Application } from "@hotwired/stimulus"
import SeguroSelectController from "./seguro_select_controller"
import ChartController from "./chart_controller"
import SeguroChartController from "./seguro_chart_controller"

const application = Application.start()
application.register("seguro-select", SeguroSelectController)
application.register("chart", ChartController)
application.register("seguro-chart", SeguroChartController)

export { application }
